module.exports = __webpack_public_path__ + "static/media/logo.f32d198e.jpg";